export enum ProfileLoadingStage {
    STARTING = 0,
    LOADING = 1,
    LOADED = 2,
    APPLIED = 3
}
